import { ActionBarContext } from "@bb-vendure/admin-ui/core";
import {
  ReviewPackagesOrderDocument,
} from "src/generated-gql/graphql";
import { take } from "rxjs";

export function reviewPackagesOrder(context: ActionBarContext) {
  const orderId = context.route.snapshot.params.id;

  context.dataService
    .mutate(ReviewPackagesOrderDocument, {
      id: orderId,
    })
    .pipe(take(1))
    .subscribe((res) => {
      if (res) {
        if (res.createPackageReviewFromOrder) {
          context.notificationService.success(
            `Create/update a package reviews sucessfully`
          );
        } else {
          context.notificationService.error(`Failed to create/update a package review`);
        }
      }
      else context.notificationService.error(`Failed to create/update a package review`);
    });
}
